import React from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import SeeQAScore from './SeeQAScore';
import { EmptyState } from '../../../../ui';
import './SeeQAScore.scss';

const SeeQAScorePage: React.FC = () => {
    const { teacherUserId } = useParams<{ teacherUserId: string }>();
    const [searchParams] = useSearchParams();
    // const teacherName = searchParams.get('teacherName') || '';
    
    if (!teacherUserId) {
        return (
            <div className="tp-qascore-page">
                <EmptyState title="Teacher User ID is required" />
            </div>
        );
    }
    
    return (
        <div className="tp-qascore-page">
            {/* <SeeQAScore teacherUserId={teacherUserId} teacherName={teacherName} /> */}
        </div>
    );
};

export default SeeQAScorePage;
